import EmployeeWorkInWorkInTable from "components/table/EmployeeWorkInWorkInTable";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

function useWorkTimeReport() {
    const [showReport, setShowReport] = useState(false);
    const { workIn, isLoading } = useSelector((state) => state.employee)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleSearch = (values) => {
        setShowReport(true)
    };

    const getTable = useCallback(() => {
        return (
            <EmployeeWorkInWorkInTable
                isLoading={isLoading}
                dataSource={workIn?.map((o) => ({
                    ...o,
                    children: o?.children?.size > 0 ? o?.children : null,
                }))}
                pagination={false}
            />
        );
    }, [isLoading, workIn]);

    return {
        showReport,
        isModalOpen,
        handleSearch,
        getTable,
        showModal,
        setIsModalOpen
    }
}

export default useWorkTimeReport;